import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const STATS = [
  { k: "13–25", v: "Target age group" },
  { k: "50K+", v: "Print copies / issue" },
  { k: "40%", v: "Tertiary students" },
  { k: "PAN-AF", v: "Distribution vision" },
];

const TIERS = [
  {
    name: "Voice",
    price: "Standard",
    perks: ["Quarter-page print", "Digital banner", "Social mention"],
  },
  {
    name: "Feature",
    price: "Premium",
    perks: ["Full-page print", "Section sponsorship", "Newsletter placement"],
    highlight: true,
  },
  {
    name: "Cover",
    price: "Signature",
    perks: ["Back-cover print", "Signature feature co-brand", "Event partnership"],
  },
];

export default function Advertisers() {
  return (
    <section id="partners" data-testid="advertisers-section" className="relative bg-[#2E1A6B] text-white overflow-hidden grain">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-14 items-start">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2AC1E0] mb-4">
              Advertisers · Sponsors · Partners
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Reach the audience shaping the next decade of Africa.
            </h2>
            <p className="mt-6 text-white/75 text-base md:text-lg max-w-lg leading-relaxed">
              Listen is distributed free through senior high schools, universities, youth centres,
              and cafés across Ghana — with a digital subscription base extending pan-African.
              Serious brands. Serious placement.
            </p>

            <a
              href="mailto:partners@listenmag.africa"
              data-testid="partners-cta-btn"
              className="mt-8 inline-flex items-center gap-2 px-6 py-4 bg-[#2AC1E0] text-[#2E1A6B] text-sm uppercase tracking-[0.2em] font-semibold hover:bg-white transition-colors"
            >
              Request media kit
              <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 gap-0 border border-white/15">
            {STATS.map((s, i) => (
              <motion.div
                key={s.v}
                data-testid={`stat-${i}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`p-6 md:p-8 border-white/15 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b" : ""}`}
              >
                <div className="font-display text-4xl md:text-6xl leading-none text-[#2AC1E0]">{s.k}</div>
                <div className="mt-3 text-[11px] uppercase tracking-[0.25em] font-semibold text-white/70">{s.v}</div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Tiers */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-0 border border-white/15">
          {TIERS.map((t) => (
            <div
              key={t.name}
              data-testid={`tier-${t.name.toLowerCase()}`}
              className={`p-6 md:p-8 border-white/15 md:border-r last:md:border-r-0 border-b md:border-b-0 flex flex-col gap-6 ${
                t.highlight ? "bg-[#2AC1E0] text-[#2E1A6B]" : ""
              }`}
            >
              <div className="flex items-baseline justify-between">
                <div className={`font-display text-3xl md:text-4xl tracking-tight ${t.highlight ? "text-[#2E1A6B]" : "text-white"}`}>
                  {t.name}
                </div>
                <div className={`text-[11px] uppercase tracking-[0.25em] font-semibold ${t.highlight ? "text-[#2E1A6B]/80" : "text-[#2AC1E0]"}`}>
                  {t.price}
                </div>
              </div>
              <ul className="space-y-3">
                {t.perks.map((p) => (
                  <li key={p} className={`text-sm flex gap-3 ${t.highlight ? "text-[#2E1A6B]/85" : "text-white/80"}`}>
                    <span className={`inline-block h-1.5 w-1.5 mt-2 ${t.highlight ? "bg-[#2E1A6B]" : "bg-[#2AC1E0]"}`} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
